let $inject = [
  "$scope",
  "TrainingService",
  "training_video",
];

class TrainingController {
  constructor(
    $scope,
    TrainingService,
    training_video
  ) {
    this.$scope = $scope;
    this.TrainingService = TrainingService;
    this.training_video = training_video;

    this.delta = 0;
    this.watchedTime = 0;
    if (training_video) {
      this.watchedTime = training_video.duration_watched;
    }

    this.vid_listen(training_video);

    this.autosave = null;
  }

  vid_listen(training_video) {
    let self = this;
    let video = document.getElementById("training-video");
    if (training_video && !training_video.complete) {
      video.currentTime = this.watchedTime;
    }

    video.addEventListener("timeupdate", function () {
      if (!video.seeking) {
        self.delta = video.currentTime - self.watchedTime;
        if (self.delta > 0) {
          self.watchedTime = video.currentTime;
        }
      }

      if (!document.hasFocus()) {
        video.pause();
      }
    });

    // prevent user from seeking
    video.addEventListener("seeking", function () {
      let delta = video.currentTime - self.watchedTime;

      if (delta > 0) {
        let was_playing = !video.paused;
        if (was_playing) {
          video.pause();
        }
        // play back from where the user started seeking after rewind or without rewind
        video.currentTime = self.watchedTime;
        if (was_playing) {
          video.play();
        }
      }
    });

    video.addEventListener("play", function () {
      if (self.watchedTime < video.duration) {
        self.autosave = setInterval(function () {
          self.auto_save_progress();
        }, 5000);
      }
    });

    video.addEventListener("pause", function () {
      clearInterval(self.autosave);
      self.auto_save_progress();
    });

    video.addEventListener("ended", function () {
      clearInterval(self.autosave);

      // here the end is detected
      self.complete_video();
    });
  }

  auto_save_progress() {
    let self = this;
    if (this.delta > 0) {

      let handleSuccess = function (response) {
        if (response.data.success) {
        }
        else {
          handleError(response);
        }
      };

      let handleError = function (response) {
      };

      this.TrainingService.auto_save_progress(self.watchedTime, handleSuccess, handleError);
    }
  }

  complete_video() {
    let self = this;

    let handleSuccess = function (response) {
      if (response.data.success) {
        self.loading = false;
      }
      else {
        handleError(response);
      }
    };

    let handleError = function (response) {
      //TODO define behaviour
      self.loading = false;
    };

    this.loading = true;
    this.TrainingService.complete_video(handleSuccess, handleError);
  }
}

TrainingController.$inject = $inject;

export default TrainingController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/pharmacist/controllers/training.controller.js
 **/